import React from 'react'
import { useLocation } from 'react-router'
import { Link } from 'react-router-dom'
import Logo from 'images/logo-white.png'
import styles from './Header.module.scss'

const HeaderButton = ({pathname, className}) => {
    switch(pathname) {
        case "/":
            return null;    
        default:
            return <Link className={className} to={"/"}>Current Openings</Link>    
    }
}


const Header = () => {
    const location = useLocation();
    
    return (
        <header className={styles.header}>
            <HeaderButton pathname={location?.pathname} className={styles.jobListings}/>
            <div
                className={styles.navControls}
                // className={
                //     sticky
                //         ? `${styles.navControls} ${styles.sticky}`
                //         : `${styles.navControls}`
                // }
            >
                <a href='https://www.mindfiresolutions.com/'>
                    <img
                        className={styles.logo}
                        src={Logo}
                        alt='Mindfire Solutions'
                    />
                </a>
                
                {/* <input
                    type='checkbox'
                    id='navbar-toggle'
                    className={styles.navbarToggle}
                />
                <label className={styles.hamburger} htmlFor='navbar-toggle'>
                    <FaBars className={styles.icon} />
                </label>
                <nav className={styles.nav}>
                    <ul>
                        <li>
                            <a
                                href='http://3.7.180.199/careers/browse-jobs/'
                                className={styles.active}
                            >
                                Apply Now
                            </a>
                        </li>
                    </ul>
                </nav> */}
            </div>
            {/* <div className={styles.jobContainer}>
                <h1>Developer</h1>
                <ol className={styles.breadcrumb}>
                    <li>
                        <a href='http://3.7.180.199/careers'>Home</a>
                    </li>
                    <li>
                        <a href='http://3.7.180.199/careers/jobs/'>Jobs</a>
                    </li>
                    <li>Developer</li>
                </ol>
            </div> */}
        </header>
    )
}

export { Header }
